// const ApiSofitexConfigUrl = "http://185.184.57.96/v2.00" 
const ApiSofitexConfigUrl = "https://api.mysofitex.com/v2.00" 

export default ApiSofitexConfigUrl;